import "./DataCenters.module.css";
import Header from "@/reusable_sections/Header";
import IndustrialHero from "./sections/IndustrialHero";
import MarkingSolutions from "./sections/MarkingSolutions";
import Applications from "./sections/Applications";
import EvermarkBenefits from "./sections/EvermarkBenefits";
import Compliance from "./sections/Compliance";
import EvermarkFaq from "./sections/EvermarkFaq";
import Finalcta from "./sections/Finalcta";
import Solutions from "./sections/Solutions";
import Footer from "@/reusable_sections/Footer";
export default function DataCentersPage() {
  return <div>
      <Header />
      <IndustrialHero />
      <MarkingSolutions />
      <Applications />
      <EvermarkBenefits />
      <Compliance />
      <EvermarkFaq />
      <Finalcta />
      <Solutions />
      <Footer />
    </div>;
}